export default function Logo() {
  return (
    <img
      src="/assets/avatars/cworks.png"
      width={50}
      height={50}
      className="me-1 rounded-sm transition-all group-data-collapsible:size-7 group-data-[collapsible=icon]:size-8"
      alt="youtube widget Admin logo"
    />
  );
}
